import { reactive } from "vue";

export const vocab = reactive({ search: "", chaps: "" });
export const data = reactive({ words: [], nouns: [], verbs: [], chapters: [] });
